import React from 'react';

interface SimpleModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const SimpleModal: React.FC<SimpleModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(10,16,50,0.10)',
      backdropFilter: 'blur(6px) saturate(1.1)',
      WebkitBackdropFilter: 'blur(6px) saturate(1.1)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background 0.3s',
    }}>
      <style>{`
        @media (max-width: 600px) {
          .simple-modal-outer { max-width: 99vw !important; min-width: 0 !important; padding: 0 !important; max-height: 99vh !important; }
          .simple-modal-inner { padding: 1.2rem 0.5rem !important; border-radius: 18px !important; }
        }
      `}</style>
      <div className="simple-modal-outer" style={{
        background: 'rgba(24,26,32,0.82)',
        borderRadius: 32,
        minWidth: 340,
        maxWidth: 760,
        width: '100%',
        maxHeight: '98vh',
        boxShadow: '0 16px 64px 0 #14F19522, 0 4px 16px 0 #0005, 0 0 0 6px #9945FF22',
        border: '2px solid rgba(20,241,149,0.18)',
        transition: 'max-width 0.3s',
        display: 'flex',
        alignItems: 'stretch',
        animation: 'fadeInModal 0.35s',
        fontFamily: '"Inter", "Segoe UI", Arial, sans-serif',
        position: 'relative',
        overflow: 'hidden',
        backdropFilter: 'blur(8px) saturate(1.1)',
      }}>
        <div className="glow-border"></div>
        <div className="simple-modal-inner" style={{
          background: 'linear-gradient(120deg, rgba(20,241,149,0.13) 0%, rgba(153,69,255,0.13) 100%)',
          borderRadius: 28,
          padding: '2.5rem 2rem 2rem 2rem',
          minWidth: 0,
          width: '100%',
          maxHeight: '90vh',
          overflowY: 'auto',
          position: 'relative',
          boxShadow: '0 4px 32px #14F19522',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <div style={{ position: 'absolute', inset: 0, borderRadius: 28, pointerEvents: 'none', background: 'radial-gradient(ellipse at 60% 0%, #14F19522 0%, transparent 70%)' }} />
          <div style={{
            fontWeight: 900,
            fontSize: '2.1rem',
            background: 'linear-gradient(90deg, #14F195 0%, #03E1FF 50%, #9945FF 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-1px',
            marginBottom: 10,
            textAlign: 'center',
            textShadow: '0 2px 16px #14F19533, 0 1px 8px #9945FF22',
          }}>Registration</div>
          <picture>
            <source srcSet="/images/branding/solana-volume-bot-mascott.avif" type="image/avif" />
            <source srcSet="/images/branding/solana-volume-bot-mascott.webp" type="image/webp" />
            <img src="/images/branding/solana-volume-bot-mascott.svg" alt="Solana Volume Bot Mascot, modal branding" style={{ width: 80, height: 80, marginBottom: 12, borderRadius: '50%', background: 'none', boxShadow: '0 4px 32px 0 #2affb733' }} loading="lazy" />
          </picture>
          <button onClick={onClose} aria-label="Close modal" style={{
            position: 'absolute',
            top: 16,
            right: 16,
            background: 'rgba(20,241,149,0.10)',
            border: 'none',
            borderRadius: '50%',
            width: 40,
            height: 40,
            fontSize: 26,
            color: 'var(--primary, #14F195)',
            cursor: 'pointer',
            transition: 'background 0.2s',
            boxShadow: '0 2px 8px #0002',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
          }}
          onMouseOver={e => (e.currentTarget.style.background = 'rgba(20,241,149,0.18)')}
          onMouseOut={e => (e.currentTarget.style.background = 'rgba(20,241,149,0.10)')}
          >
            &times;
          </button>
          <div style={{ width: '100%', marginTop: 8 }}>{children}</div>
        </div>
      </div>
    </div>
  );
}; 